import { Injectable, WritableSignal, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SearchBridgeService {
  query: WritableSignal<string> = signal('');
  visible: WritableSignal<boolean> = signal(false);

  push(value: string): void {
    this.query.set(value);
    this.visible.set(value.length >= 2);
  }

  setVisible(value: boolean): void {
    this.visible.set(value);
  }
}
